import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore, selectIsAdmin, selectIsAuthenticated, selectIsPending } from '../store/authStore';

function AdminRoute({ children }) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const isAdmin = useAuthStore(selectIsAdmin);
  const isPending = useAuthStore(selectIsPending);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isPending) {
    return <Navigate to="/pending" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
}

export default AdminRoute;
